import { useCallback, useState, createContext, useMemo } from "react";

export const defaultContext: IUserContext = {
    portalVersion: "",
    companyId: "",
    companyName: "",
    companyStatus: "",
    companySystems: "",
    companies: 0,
    environment: "",
    isAuthenticated: undefined,
    isCalanceAdmin: "0",
    landingPage: "",
    gitHash: "",
    buildDate: "",
    matchTools: [],
    machineName: "",
    permissions: {},
    preferences: {},
    procoreLoginCompanies: [],
    statusMessages: [],
    username: "",
    userId: "",
};

const defaultContextValue: IUserContextValue = [
    defaultContext,
    (context: Partial<IUserContext>): void => {},
];

export const UserContext =
    createContext<IUserContextValue>(defaultContextValue);

/** @component Higher order component that wraps the component tree to provide
 * context (our userContext state) to anywhere in the app. This exists
 * so this code does not need to be in App.tsx.
 */
export default function UserContextProvider({
    children,
}: {
    readonly children: React.ReactNode;
}) {
    // State is getting stored in react context
    const [userContext, setUserContext] =
        useState<IUserContext>(defaultContext);

    /** Updates user context state with any key/value pairs passed in.
     *  @param context An object that can have all key/value pairs or just one/some. */
    const onSetUserContext = useCallback((context: Partial<IUserContext>) => {
        setUserContext((prev) => ({ ...prev, ...context }));
    }, []);

    const value = useMemo<IUserContextValue>(
        () => [userContext, onSetUserContext],
        [userContext, onSetUserContext]
    );

    return (
        <UserContext.Provider value={value}>{children}</UserContext.Provider>
    );
}
